import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useFormik } from "formik";
import TextInput from "../../common/textfield/TextInput";
import { Button } from "../../common/Button";
import { failed, success } from "../../common/Toastify";
import { DURATION_PRESETS, serviceCategorySchema } from "./constants";
import { updateServiceCategory } from "../../api/Scheduling/serviceCategories";
import { schedulingErrorMessage } from "../../api/Scheduling/errors";
import CategorySlotExample from "./CategorySlotExample";
import "./Scheduling.css";

const EditCategory = ({ modalShow, handleShow, refreshTable }) => {
  const [btnLoading, setBtnLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      organizationRef: "",
      serviceCategoryId: "",
      code: "",
      name: "",
      durationMinutes: 30,
      bookingIncrementMinutes: 5,
      version: 1,
    },
    validationSchema: serviceCategorySchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      setBtnLoading(true);
      updateServiceCategory({
        organizationRef: values.organizationRef,
        serviceCategoryId: values.serviceCategoryId,
        code: values.code.trim(),
        name: values.name.trim(),
        durationMinutes: Number(values.durationMinutes),
        bookingIncrementMinutes: Number(values.bookingIncrementMinutes),
        expectedVersion: values.version,
      })
        .then(() => {
          success("Schedule category updated");
          handleShow();
          refreshTable?.();
        })
        .catch((error) => failed(schedulingErrorMessage(error)))
        .finally(() => setBtnLoading(false));
    },
  });

  useEffect(() => {
    if (!modalShow?.serviceCategoryId) return;
    formik.setValues({
      organizationRef: modalShow.organizationRef || "",
      serviceCategoryId: modalShow.serviceCategoryId,
      code: modalShow.code || "",
      name: modalShow.name || "",
      durationMinutes: modalShow.durationMinutes || 30,
      bookingIncrementMinutes: modalShow.bookingIncrementMinutes || 5,
      version: modalShow.version || 1,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalShow]);

  if (!modalShow) return null;

  return (
    <Modal
      show={!!modalShow}
      onHide={handleShow}
      size="lg"
      centered
      className="custom-dialog"
      backdrop="static"
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title>Schedule Category Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="common-form border-fields" onSubmit={formik.handleSubmit}>
          <input type="hidden" name="version" value={formik.values.version} />
          <Row>
            <Col>
              <TextInput keyField="code" label="Code" formik={formik} placeholder="CONSULT" disabled />
            </Col>
            <Col>
              <TextInput keyField="name" label="Name" formik={formik} placeholder="Initial Consultation" />
            </Col>
          </Row>
          <div className="scheduling-preset-row">
            {DURATION_PRESETS.map((minutes) => (
              <button
                type="button"
                key={minutes}
                onClick={() => formik.setFieldValue("durationMinutes", minutes)}
              >
                {minutes} min
              </button>
            ))}
          </div>
          <Row>
            <Col>
              <TextInput
                keyField="durationMinutes"
                label="Duration minutes"
                type="number"
                formik={formik}
                placeholder="30"
              />
            </Col>
            <Col>
              <TextInput
                keyField="bookingIncrementMinutes"
                label="Booking increment"
                type="number"
                formik={formik}
                placeholder="5"
              />
            </Col>
          </Row>
          <CategorySlotExample
            durationMinutes={formik.values.durationMinutes}
            bookingIncrementMinutes={formik.values.bookingIncrementMinutes}
          />
          <div className="btn-wrap" style={{ display: "flex", marginTop: "1rem" }}>
            <Button variant="secondary" onClick={handleShow}>
              Cancel
            </Button>
            <Button type="submit" isLoading={btnLoading}>
              Update
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default EditCategory;
